// Shape canónico de error que devuelve la API y consumen las apps.
// Todas las respuestas no-OK siguen este contrato.
import { z } from 'zod';

export const ApiErrorSchema = z.object({
  status: z.number().int(),
  code: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;

export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
  uptime: z.number().nonnegative(),
  version: z.string(),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;
